import { DELIMITER, LISTING_STATUSES } from '../constants/ClickstreamConstants';

const getListingStatusSuffix = (isActive: boolean, dateLastActivatedTimestamp: string) => {
  if (isActive) {
    return `${DELIMITER}${LISTING_STATUSES.ACTIVE}`;
  }
  if (dateLastActivatedTimestamp !== '') {
    return `${DELIMITER}${LISTING_STATUSES.OFF_MARKET}`;
  }
  // new listing - do not append suffix to CS trigger location
  return '';
};

// TODO: consider adding a util to get the CS tracking location/specific step that uses the pathname (/listing or /create-listing) plus the modularListingProgress step
// e.g. "posting_path_review"
// Need to fix https://zillowgroup.atlassian.net/browse/ZRM-12573 first

export default { getListingStatusSuffix };
